export function toTitleCase(label: string): string {
  if (!label) return "";

  const withSpaces = label
    .replace(/([a-z])([A-Z])/g, "$1 $2")    // handle camelCase
    .replace(/[_\-]+/g, " ");               // handle snake_case & kebab-case

  return withSpaces
    .trim()
    .split(/\s+/)
    .map(
      word =>
        word.charAt(0).toUpperCase() +      // Capitalize first letter
        word.slice(1).toLowerCase()         // Lowercase rest
    )
    .join(" ");
}

/**
 * Capitalises a person's name for display without flattening the rest of it.
 *
 * Candidates type their own name at sign-up, so it regularly arrives as
 * "john doe" and rendered straight into the report header. toTitleCase is the
 * wrong tool here: it lowercases every character after the first, which would
 * mangle "McDonald" and "O'Brien", and it splits camelCase. This only touches a
 * lowercase letter that starts a name part, leaving deliberate capitals alone.
 */
export function formatPersonName(name: string): string {
  if (!name) return "";

  return name
    .trim()
    .replace(/\s+/g, " ")
    .replace(/(^|[\s'\u2019-])([a-z])/g, (_match, separator, letter) => separator + letter.toUpperCase());
}
